import React, { useContext, useEffect } from 'react';

// firebase
import firebase from 'firebase/app';
import 'firebase/auth';
import { Redirect } from 'react-router';

// store
import { StoreContext } from '../../store/StoreProvider';
import act from '../../store/actions';

const SignOut = () => {
	const isLogin = JSON.parse(localStorage.getItem('isLogin'));

	// eslint-disable-next-line no-unused-vars
	const [_, dispatch] = useContext(StoreContext);

	useEffect(() => {
		if (isLogin) {
			// SignOut firebase
			firebase
				.auth()
				.signOut()
				.then(() => {
					// Sign-out successful.
				})
				.catch((error) => {
					// An error happened.
					// eslint-disable-next-line no-console
					console.log(error);
				});
			// clean user data
			dispatch({ type: act.FIREBASE_LOGOUT_USER });
			// clean localStorage
			localStorage.removeItem('isLogin');
		} else {
			// console.log('do nothing');
		}
	});

	return <Redirect to="/SignIn" />;
};

export default SignOut;
